import { Component, ElementRef, ViewChild } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { InputGeneralVariantComponent } from '../input-general-variant/input-general-variant.component';
import { TextAreaGeneralVariantComponent } from '../textarea-general-variant/textarea-general-variant.component';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { HomePageService } from '../home.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-submit-yours',
    templateUrl: './submit-yours.component.html',
    standalone: true,
    imports: [
        InputGeneralVariantComponent,
        TextAreaGeneralVariantComponent,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatDialogModule,
        TranslateModule,
        CommonModule,
    ],
})
export class SubmitYoursComponent {
    @ViewChild('fileInput') fileInput: ElementRef;

    submitYoursForm: FormGroup;
    submitted = false;
    public captchaResolved: boolean = false;
    photoPreview: string;
    isRequired;

    constructor(
        private fb: FormBuilder,
        private translate: TranslateService,
        private homePageService: HomePageService,
        public dialogRef: MatDialogRef<SubmitYoursComponent>,
        private toastr: ToastrService,
    ) {}

    ngOnInit(): void {
        this.submitYoursForm = this.fb.group({
            customerName: ['', Validators.required],
            customerTitle: ['', [Validators.required]],
            testimonyDetail: ['', [Validators.required]],
            pictureUrl: [' ', Validators.required],
        });

        this.translate.get('ERROR.IS_REQUIRED').subscribe((data: any) => {
            this.isRequired = data;
        });
    }

    triggerFileInput() {
        this.fileInput.nativeElement.click();
    }

    getErrors(input: any, inputName?: any): Array<any> {
        let errors = [];

        if (this.f[input].touched || this.submitted) {
            if (this.f[input].errors?.required) {
                errors.push(inputName + ' ' + this.isRequired);
            }
        }
        return errors;
    }

    onPhotoUpload(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        const file = (inputElement.files as FileList)[0];

        if (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.photoPreview = e.target.result as string;
                this.submitYoursForm.controls['pictureUrl'].setValue(file.name);
            };

            reader.readAsDataURL(file);
        }
    }

    get f() {
        return this.submitYoursForm.controls;
    }

    onSubmitYours() {
        this.submitted = true;
        if (this.submitYoursForm.valid) {
            this.homePageService
                .postCustomerFeedback(this.submitYoursForm.value)
                .subscribe((data) => {});

            this.toastr.success('Submitted Successful','Success');

            setTimeout(() => {
                this.dialogRef.close();
            }, 2000);
        }
    }
}
